import DrawerBasic, { IDrawerBasicProps } from "../../../../Base/Drawer/DrawerBasic";
import TituloMovimentacaoScreen from "./TituloMovimentacaoScreen";
import { useNavigate } from "react-router-dom";

export interface ITituloMovimentacaoDrawerProps extends IDrawerBasicProps {
    codTitulo:number;
}

export default function TituloMovimentacaoDrawer({
    codTitulo,
    elementoGatilho,
    destroyOnClose,
    ...props
}:ITituloMovimentacaoDrawerProps) {
    const navigate = useNavigate();

    destroyOnClose = destroyOnClose === undefined ? true : destroyOnClose;
    
    return <DrawerBasic {...props} elementoGatilho={elementoGatilho} destroyOnClose={destroyOnClose}>
        <TituloMovimentacaoScreen codTitulo={codTitulo} />
    </DrawerBasic>;
}